import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { 
  GET_VENDOR_MEDIA, 
  // GET_ADMIN_PROFILE,
  ADD_NEW_VENDOR_MEDIA,
  UPDATE_VENDOR_MEDIA,
  DELETE_VENDOR_MEDIA
 } from "./actionTypes";
import {
  getVendor_mediaSuccess,
  getVendor_mediaFail,
  addVendor_mediaSuccess,
  addVendor_mediaFail,
  updateVendor_mediaSuccess,
  updateVendor_mediaFail,
  deleteVendor_mediaSuccess,
  deleteVendor_mediaFail,
  // getVendor_mediaProfileSuccess,
  // getVendor_mediaProfileFail,
} from "./actions";

//Include Both Helper File with needed methods
import { 
  getVendor_media,
  // getVendor_mediaProfile,
  addNewVendor_media,
  updateVendor_media,
  deleteVendor_media,
} from "../../helpers/backend_helper";
import { showPopup } from "../popup/actions";

function* fetchVendor_media({payload:{id,offset,page_size}}) {
  try {
    const response = yield call(getVendor_media,{id,offset,page_size});
    yield put(getVendor_mediaSuccess(response));
    
  } catch (error) {
    yield put(getVendor_mediaFail(error));
      yield put(showPopup({title:error.response.data.message,error:true}));

  }
}

function* onUpdateVendor_media({ payload: { user, history } }) {
  try {
    let response = yield call(updateVendor_media, user)
    // if (response.file_src || user.removeImage)
    //   user.image = response.file_src
    yield put(updateVendor_mediaSuccess(user))
    yield put(showPopup({title:response.message,success:true}));

   if (history) {
     history.goBack()
   } 
  } catch (error) {
    yield put(updateVendor_mediaFail(error))
      yield put(showPopup({title:error.response.data.message,error:true}));

  }
}

function* onDeleteVendor_media({ payload: ceremony }) {
  
  try {
    let response =  yield call(deleteVendor_media, ceremony);
    yield put(deleteVendor_mediaSuccess(ceremony));
    yield put(showPopup({title:response.message,success:true}));

  } catch (error) {
    yield put(deleteVendor_mediaFail(error));
      yield put(showPopup({title:error.response.data.message,error:true}));

  }
}

function* onAddNewVendor_media({ payload: {user, history } }) {
  try {
    const response =  yield call(addNewVendor_media, user);
    yield put(addVendor_mediaSuccess(response.data));
    yield put(showPopup({title:response.message,success:true}));

    if (history) {
     history.goBack() 
   } 
  } catch (error) {
    yield put(addVendor_mediaFail(error));
      yield put(showPopup({title:error.response.data.message,error:true}));

  }
}


// function* fetchVendor_catProfile() {
//   try {
//     const response = yield call(getVendor_catProfile);
//     yield put(getVendor_catProfileSuccess(response));
//   } catch (error) {
//     yield put(getVendor_catProfileFail(error));
//   }
// }

function* ceremonysSaga() {
  yield takeEvery(GET_VENDOR_MEDIA, fetchVendor_media);
  yield takeEvery(ADD_NEW_VENDOR_MEDIA, onAddNewVendor_media);
  yield takeEvery(UPDATE_VENDOR_MEDIA, onUpdateVendor_media);
  yield takeEvery(DELETE_VENDOR_MEDIA, onDeleteVendor_media);
  // yield takeEvery(GET_ADMIN_PROFILE, fetchVendor_catProfile);
}

export default ceremonysSaga;
